import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { fbind } from 'q';
import { EmailBody } from '../Models/EmailBody';
import { AppHttpService } from '../AppServices/app.httpservices';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {

  public isSuccess = false;
  public isSubmitted = false;
  public isSubmitting = false;
  group: FormGroup
  constructor(private fb: FormBuilder, private httpService: AppHttpService) { }

  ngOnInit() {
     this.group = this.fb.group ({
       name: new FormControl('', Validators.required),
       message: new FormControl('', Validators.required),
       fromEmail: new FormControl('', Validators.required),
       fromPhone: new FormControl('', Validators.required)
     });
  }

  SubmitMessage() {
    
    const email = new EmailBody();
    email.Name = this.group.get('name').value;
    email.Message = this.group.get('message').value;
    email.FromEmail = this.group.get('fromEmail').value;
    email.FromPhone = this.group.get('fromPhone').value;
    if(email.Name.length > 0 && email.Message.length > 0 && email.FromEmail.length > 0) {
        this.isSubmitting = true;
        this.httpService.post<any>("api/Email/SendEmail", email).subscribe(data => {
          this.isSubmitted = true;
          this.isSuccess = data;
          this.group.get('name').setValue('');
          this.group.get('message').setValue('');
          this.group.get('fromEmail').setValue('');
          this.group.get('name').markAsUntouched();
          this.group.get('message').markAsUntouched();
          this.group.get('fromEmail').markAsUntouched();
          this.group.get('name').markAsPristine();
          this.group.get('message').markAsPristine();
          this.group.get('fromEmail').markAsPristine();
          this.group.get('fromPhone').markAsUntouched();
          this.group.get('fromPhone').markAsPristine();
          this.isSubmitting = false;
       
        }, error => {
          this.isSubmitted = true;
          this.isSuccess = false;
          this.isSubmitting = false;
        });
    }
  }

}
